import { baseRequest } from '@/utils/request'

const request = (url, ...arg) =>  baseRequest(`/biz/c/jobapply/${url}`, ...arg)
/**
 * 我的投递接口管理
 *
 */
export default {
	// 企业收到投递分页
	enterprisePage(data) {
		return request('enterprisePage', data, 'get')
	},
	// 用户投递分页
	page(data) {
		return request('page', data, 'get')
	},
	// 详情
	detail(data) {
		return request('detail', data, 'get')
	},
	// 删除
	delete(data) {
		return request('delete', data)
	},
	// 自主投递简历
	deliver(data) {
		return request('deliver', data)
	},
	// 企业从简历发起面试邀请
	resumeInvite(data) {
		return request('resumeInvite', data)
	},
	// 企业从收到的投递发起面试邀请
	sendInvite(data) {
		return request('sendInvite', data)
	},
	// 拒绝投递
	refuse(data) {
		return request('refuse', data)
	},
	// 接受面试邀约
	confirmInvite(data) {
		return request('confirmInvite', data)
	},
	// 婉拒面试邀约
	refuseInvite(data) {
		return request('refuseInvite', data)
	},
	// 修改职位投递查看状态
	changeView(data) {
		return request('changeView', data, 'get')
	},
	// 获取企业收到投递代办数量
	enterprisePendTotal(data) {
		return request('enterprisePendTotal', data, 'get')
	},
	// 更新备注
	editRemarks(data) {
		return request('editRemarks', data)
	},
	// 点击其他，更新状态为已处理
	otherRemarks(data) {
		return request('otherRemarks', data)
	},
}
